module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/planning2-f53fb6ba04388ac5c74b4113d883241a.png";